import Alert from '@jetbrains/ring-ui-built/components/alert/alert'
import { Text } from '@qodana/blocks/lib/components/Typography'

import styles from './FetchErrorNotification.module.css'

type FetchErrorNotificationProps = {
	url?: string
	status: number | string
	data?: unknown
}

const hasData = (data: unknown): boolean => {
	if (data === null || data === undefined) {
		return false
	}
	if (typeof data === 'string') {
		return data.trim().length > 0
	}
	return true
}

export const FetchErrorNotification = ({ status, url, data }: FetchErrorNotificationProps) => {
	let formattedData
	if (hasData(data)) {
		try {
			formattedData = JSON.stringify(data, undefined, 2)
		} catch {
			console.error("Couldn't format data: ", data)
		}
	}

	return (
		<div>
			<Alert.Heading>Request failed, status: {status}</Alert.Heading>
			{!!url && <Text title={url}>{url}</Text>}
			{!!formattedData && (
				<pre data-test="fetch-error-data" className={styles.data}>
					{formattedData}
				</pre>
			)}
		</div>
	)
}
